import React from "react";
import {format} from "date-fns";

export const DatepickerHeader = ({
                                     date,
                                     decreaseMonth,
                                     increaseMonth,
                                     prevMonthButtonDisabled,
                                     nextMonthButtonDisabled,
                                     localeObject
                                 }) => {

    return (
        <div className={'datepicker-header'}>
            <button type="button"
                    className={'datepicker-nav'}
                    onClick={decreaseMonth}
                    disabled={prevMonthButtonDisabled}>
                ‹
            </button>
            <span className={'datepicker-header-label'}>
                                            {format(date, 'LLLL yyyy', {locale: localeObject})}
                                        </span>
            <button type="button"
                    className={'datepicker-nav'}
                    onClick={increaseMonth}
                    disabled={nextMonthButtonDisabled}>
                ›
            </button>
        </div>
    );
}